import { createContext } from "react";

const paramPays ={
    pays : "NE",
    adminpaysExiste: false
    
  }
  
  
const PaysContext = createContext(paramPays.pays);
export default PaysContext;
